export default {
  'entityName': 'account',
  pagination: {
    'itemsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  filterStorage: {},
  'fields': [
    // {
    //   value: 'id',
    //   text: 'ID',
    //   visible:false,
    //   'type': 'text',
    //   'table': {
    //     'sortable': true,
    //     'filter': true
    //   },
    // },

    {
      value: 'email',
      text: 'Email',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
        'email'
      ]
    },

    {
      value: 'username',
      text: 'Username',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required'
      ]
    },
    // {
    //   value: 'username',
    //   text: 'Username',
    //   'type': 'text',
    //   'table': {
    //     'sortable': true,
    //     'filter': true
    //   },
    //   'validators': [
    //     'required',
    //   ]
    // },
    {
      value: 'name',
      text: 'Name',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      render: item => `${item.name} ${item.surname}`,
      validators: ['required']
    },
    {
      value: 'surname',
      text: 'Surname',
      type: 'text',
      default: null,
      validators: [ 
        (field, value) => {
          return value !== '' || 'Surname is required'
        },
      ],
    },



    {
      value: 'role',
      text: 'Role',
      'type': 'list',
      'table': {
        'sortable': true,
        filter: true
      },
      'list': () => {
        let types = [
          'Administrator',
          'Marketing',
          'Admin Reparto',
          'QG Client'
        ]
        // if (state.user.role === 'Administrator') {
        //   types.unshift('Administrator')
        // }
        return types
      },
      tooltip: () => {
        return null
      },
      'validators': [
        'required'
      ]
    },
    {
      value: 'status',
      text: 'Status',
      'type': 'list',
      'table': {
        'sortable': true,
        'filter': true
      },
      'list': [
        'Active',
        'Disabled',
      ],
      'validators': [
        'required'
      ],
    }
  ],
  actions: [
    // { "value": "emulateUser", "text": "Emulate User", "icon": "mdi-head-sync-outline", "color": "primary", 
    //   disable: (item) => {
    //     return item.role == 'Administrator' || item.role == 'QG Client'
    //   }
    // },
    'upsert','remove'
  ]
}
